import type { CounterReasonEntry, SynergyReasonEntry } from '../utils/winRateDelta';
import { heroDisplayName } from '../../tierlist/utils/heroDisplayName';
import { RecommendationMiniThumb } from './RecommendationMiniThumb';

export function CounterReasonRow({ reason }: { reason: CounterReasonEntry }) {
  const oppName = heroDisplayName(reason.opponentId, reason.opponentName);
  const label = reason.value > 0 ? `${oppName}に有利` : `${oppName}に不利`;
  return (
    <div className={`reason-item counter ${reason.value >= 0 ? 'positive' : 'negative'}`}>
      <span className="reason-label-row">
        <RecommendationMiniThumb headUrl={reason.opponentHeadUrl} displayName={oppName} />
        <span className="reason-label">{label}</span>
      </span>
      <span className="reason-value">
        {reason.value >= 0 ? '+' : ''}
        {(reason.value * 100).toFixed(1)}%
      </span>
    </div>
  );
}

export function SynergyReasonRow({ reason }: { reason: SynergyReasonEntry }) {
  const partnerName = heroDisplayName(reason.partnerId, reason.partnerName);
  return (
    <div className={`reason-item synergy ${reason.value >= 0 ? 'positive' : 'negative'}`}>
      <span className="reason-label-row">
        <RecommendationMiniThumb headUrl={reason.partnerHeadUrl} displayName={partnerName} />
        <span className="reason-label">
          シナジー（{partnerName}）
        </span>
      </span>
      <span className="reason-value">
        {reason.value >= 0 ? '+' : ''}
        {(reason.value * 100).toFixed(1)}%
      </span>
    </div>
  );
}
